import apiUrl from "../../../../utils/settings";

export const createPaymentUrl = () => {
  return apiUrl + '/ledger-transaction';
};
export const updatePaymentUrl = () => {
  return apiUrl + '/ledger-transaction';
};
export const getPaymentHistoryUrl = () => {
  return apiUrl + '/ledger-transaction/payment-history';
};